import { Routes, Route, Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Loading from "../Loading/Loading";
import axios from "axios";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import VacationLineInformation from "./VacationLineInformation";

function formatDate(date) {
  let dateObj = new Date(date);
  let month = parseInt(dateObj.getMonth()) + 1;
  return dateObj.getDate() + "." + month + "." + dateObj.getFullYear();
}

function formatMonth(monthNo) {
  const monthNames = ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
  return monthNames[monthNo];
}

export default function Vacation() {
  const [loading, setLoading] = useState(true);
  const [vacationData, setVacationData] = useState([]);
  const [vacationDays, setVacationDays] = useState(0);
  const [vacationHours, setVacationHours] = useState(0);

  const [viewedEntry, setViewedEntry] = useState(null);
  const [vacationLineInformationOpen, setVacationLineInformationOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      let response = await axios.get(`/api/vacation`);
      setVacationData(processRows(response.data.data));
      setVacationDays(response.data.vacationBalanceDays);
      setVacationHours(response.data.vacationBalanceHours);
      console.log(response.data)
      setLoading(false);
    }

    fetchData()
      .catch(console.error);
  }, []);

  const processRows = rows => {
    let sorted = rows.sort(function (a, b) { return new Date(b.date) - new Date(a.date); });
    let formattedRows = [];
    let tmp = [];
    let currentMonth = sorted[0].monthNo;
    sorted.forEach(row => {
      if (row.monthNo === currentMonth) {
        tmp.push(row);
      } else {
        formattedRows.push(tmp);
        currentMonth = row.monthNo;
        tmp = [];
        tmp.push(row)
      }
    })

    if (tmp.length > 0) {
      formattedRows.push(tmp)
    }
    return formattedRows;
  }

  const closeModal = () => {
    setViewedEntry(null);
    setVacationLineInformationOpen(false);
  };

  if (loading) {
    return <Loading />
  } else {
    return (
      <div>
        <VacationLineInformation
          open={vacationLineInformationOpen}
          entry={viewedEntry}
          handleClose={closeModal}
        />
        <Card sx={{ minWidth: 275 }}>
          <CardContent>
            <Typography variant="h6" component="div">
              Remaining vacation
            </Typography>
            <Typography color="text.secondary">
              Days: <strong>{vacationDays}</strong>
            </Typography>
            <Typography color="text.secondary">
              Hours: <strong>{vacationHours}</strong>
            </Typography>
            <br />
            <Typography variant="h6" component="div" style={{ marginBottom: -15 }}>
              Recently registered vacation days
            </Typography>
          </CardContent>
        </Card>



        <TableContainer component={Paper}>

          <Table sx={{ minWidth: "100%" }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell style={{ fontSize: 13, fontWeight: "bold" }}>Week</TableCell>
                <TableCell style={{ fontSize: 13, fontWeight: "bold" }}>Month</TableCell>
                <TableCell style={{ fontSize: 13, fontWeight: "bold" }}>Date</TableCell>
                <TableCell style={{ fontSize: 13, fontWeight: "bold" }} align="right">Hours</TableCell>
                <TableCell style={{ fontSize: 13, fontWeight: "bold" }} align="right">Status</TableCell>
              </TableRow>
            </TableHead>
          </Table>
          {vacationData.length > 0 && (vacationData.map((formattedRows, i) => (
            <Table sx={{ width: "100%", marginBottom: 3 }} key={i}>
              <TableBody>
                {formattedRows.length > 0 && (formattedRows.map((row, index) => (
                  <TableRow
                    key={index}
                    onClick={() => { setViewedEntry(row); setVacationLineInformationOpen(true); }}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: "pointer"  }}
                    style={row.status === "Submitted" || row.status === "Approved" || row.status === "Pending" ? { backgroundColor: "#c3e6cb" } : { backgroundColor: "#f5c6cb" }}>
                    <TableCell component="th" scope="row" style={{ width: 30 }}>{row.weekNo}</TableCell>
                    <TableCell component="th" scope="row" style={{ width: 30 }} align="left">{formatMonth(row.monthNo)}</TableCell>
                    <TableCell component="th" scope="row" style={{ minWidth: 1 }}>{formatDate(row.date)}</TableCell>
                    <TableCell align="right">{row.quantity}</TableCell>
                    <TableCell align="right" style={{ width: 60 }}>{row.status}</TableCell>
                  </TableRow>
                )))}
              </TableBody>
            </Table>
          )))}
        </TableContainer>
      </div>
    );
  }
}